module.exports = __webpack_public_path__ + "assets/img/intelligentControl_a.57e56b52.jpg";